module.exports = __webpack_public_path__ + "static/fabric-shimmer-styles-waves-628ee82ef9b42013a898448932e04929.gif";